import React, { Component } from 'react'
import MenuNav from './components/menu/menu.component'
import ContactForm from './components/contact/contact.component'
import TerrainGenerator from './components/terrain'
import WebAudio from './components/web-audio'
import WebAudioMobile from './components/web-audio/mobile'
import BallPhysics from './components/ball-physics'
import MazeGenerator from './components/maze-generator'
import { Card } from 'semantic-ui-react'
import './App.css'

const isMobileAgent = navigator.userAgent.includes('Mobile')

class App extends Component {
  constructor(props) {
    super(props)
    this.state = { nav: 'home' }
    this.navUpdate = this.navUpdate.bind(this)
  }

  navUpdate(name) {
    this.setState(Object.assign({}, this.state, { nav: name }))
  }

  render() {
    return (
      <div className="App">
        <MenuNav onChange={this.navUpdate} />
        {this.state.nav === 'home' && (
          <Card header="Devtanc's Portfolio" centered />
        )}
        {this.state.nav === 'terrainGenerator' && <TerrainGenerator />}
        {this.state.nav === 'contactMe' && (
          <ContactForm
            siteKey="6LdoIUUUAAAAAC7U9zOSJNC8xIlhoJgVvPHKi_Dk"
            submitUrl="https://api.devtanc.com/dev/v1/email"
            cors
          />
        )}
        {this.state.nav === 'webAudio' && !isMobileAgent && <WebAudio />}
        {this.state.nav === 'webAudio' && isMobileAgent && <WebAudioMobile />}
        {this.state.nav === 'ballPhysics' && <BallPhysics />}
        {this.state.nav === 'mazeGenerator' && <MazeGenerator />}
      </div>
    )
  }
}

export default App
